module.exports = __webpack_public_path__ + "static/media/01.44c0a49e.jpg";